angular.module('tax', ['core'])
    .factory('Tax', function ($resource) {
        return $resource('/crm/api/tax/:id', {}, {
            list: {method: 'GET'},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/tax/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        })
    })
    .service('TaxService', function ($rootScope, modals, Tax) {
        this.editModal = entity => modals.open('app/tax/edit-modal.html', 'TaxDialogController', entity, {size: 'md'}, "$ctrl")
        this.addModal = () => {
            let entity = {
                default: false,
                active: true,
                id: null
            }
            return this.editModal(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => Tax.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('tax.updated')))
        }
    })
    .controller('TaxDialogController', function ($timeout, $scope, $rootScope, $uibModalInstance, data, toastr, Tax) {
        this.item = data

        this.cancel = () => $uibModalInstance.dismiss('Canceled')

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Tax.update(this.item).$promise
            } else {
                promise = Tax.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast('tax.updated')
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('taxList', {
            parent: 'app',
            url: '/tax?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "taxList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Tax, $stateParams) => Tax.table(angular.copy($stateParams)).$promise
            }
        })
    })
